<template>
  <div class="edt">
    <v-app-bar
      flat
      color="transparent"
      class="main-appbar"
    >
      <app-bar-nav-icon />
      <div class="d-flex align-center">
        <v-toolbar-title>
          <h1 class="headline font-weight-bold">App Settings
          </h1>
        </v-toolbar-title>
      </div>
      <v-spacer />
      <div>
        <!-- <v-btn
          color="primary"
          class="mr-4"
          medium
          @click="onCancel"
          :disabled="form.$busy"
          text
          style="text-transform: none;"
        >Cancel</v-btn> -->
        <v-btn
          color="primary"
          medium
          @click="onSave"
          :loading="form.$busy"
          style="text-transform: none;"
        >Save</v-btn>
      </div>
    </v-app-bar>
    <v-row class="px-4 py-4">
      <v-col
        lg="12"
        md="12"
        sm="12"
        xs="12"
      >
        <v-card
          outlined
          class="px-6 py-8"
        >

          <v-text-field
            outlined
            flat
            label="App Name"
            v-model="form.title"
            :error-messages="form.$getError('title')"
          />

          <v-textarea
            outlined
            name="input-7-4"
            label="Description"
            v-model="form.description"
            :error-messages="form.$getError('description')"
          />

          <v-textarea
            outlined
            name="input-7-4"
            label="Default Promo Disclaimer"
            v-model="form.disclaimer_text"
            :error-messages="form.$getError('disclaimer_text')"
          />
          <v-textarea
            outlined
            name="input-7-4"
            label="Default BetHub match meta description template"
            v-model="form.hypometer_seo_description"
            :error-messages="form.$getError('hypometer_seo_description')"
            hint="${homeTeam} and ${visitingTeam} will be automaticall replaced by the actual team names based on the match ID"
          />
          <br>
          <image-file-input-viewer
            v-model="form.logo"
            :error-messages="form.$getError('logo')"
            label="App Logo"
          />
        </v-card>
      </v-col>
    </v-row>
    <v-overlay
      absolute
      :value="loading"
    >
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            {{ loading_message }}
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
    <v-snackbar
      v-model="snackbar.show"
      right
      :color="snackbar.color"
    >
      {{ snackbar.message }}
      <v-btn
        text
        @click="snackbar.show = false"
      >OK</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import Form from '@/utils/form'
import get from 'lodash/get'
import find from 'lodash/find'
import AppSettings from '@/models/AppSettings'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import ImageFileInputViewer from '@/components/ImageFileInputViewer'
import ContentEditor from '@/components/ContentEditor'
import { mapState, mapActions } from 'vuex'

const initialData = {
  title: null,
  description: null,
  logo: null,
  disclaimer_text: null
}

export default {
  data () {
    return {
      loading: false,
      updating: false,
      loading_message: 'Loading',
      snackbar: {
        show: false,
        message: null,
        color: 'success'
      },
      loadingTags: false,
      form: new Form({
        ...initialData
      })
    }
  },
  props: {

    redirectCancelTo: {
      type: [String, Object],
      default () {
        return {
          name: 'app-settings'
        }
      }
    },
    redirectSaveTo: {
      type: [String, Object],
      default () {
        return {
          name: 'app-settings'
        }
      }
    }
  },

  components: {
    AppBarNavIcon,
    ImageFileInputViewer
  },

  methods: {
    ...mapActions({
      getData: 'appSettings/getData',
      updateRecord: 'appSettings/update'
    }),

    onCancel () {
      this.$router.replace(this.redirectCancelTo)
    },

    async onSave () {
      try {
        this.loading = true
        this.form.$busy = true
        this.form.$clearErrors()
        const data = this.form.$data()

        if (this.isModeUpdate) {
          let formData = new FormData()
          formData.append('id', data.id)
          // formData.append('_method', 'put')
          formData.append('title', data.title)
          formData.append('description', data.description)
          formData.append('disclaimer_text', data.disclaimer_text)
          formData.append('hypometer_seo_description', data.hypometer_seo_description)

          if (typeof (data.logo.id) === 'undefined' && data.logo !== null) {
            formData.append('logo', data.logo)
          }

          await this.updateRecord(formData)
        } else {
          const appSettings = new AppSettings(data)
          await appSettings.save()
        }

        // this.$router.replace(this.redirectSaveTo)

        await this.getAppData()
      } catch (error) {
        if (get(error, 'response.status') === 422) {
          if (get(error, 'response.data.errors') !== null) {
            this.form.$setErrors(get(error, 'response.data.errors'))
          } else {
            this.showSnackbar('Something went wrong.', 'error')
          }
        } else {
          this.showSnackbar(error, 'error')
        }
      } finally {
        this.form.$busy = false
      }
    },
    showSnackbar (message, color = 'success') {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    },

    async getAppData () {
      this.loading = true
      this.loading_message = 'Loading'
      await this.getData()
        .catch(error => {
          let err = error
        })
      this.loading = false
      if (this.requestMsg) this.showSnackbar(this.requestMsg)
    }
  },

  watch: {
    appDetails: {
      immediate: true,
      handler (val) {
        if (val) {
          this.form = new Form({
            ...initialData,
            ...val

          })
        }
      }
    }
  },

  computed: {

    ...mapState({
      appDetails: state => state.appSettings.appDetails,
      requestStatus: state => state.appSettings.requestStatus,
      requestMsg: state => state.appSettings.requestMsg
    }),

    isModeUpdate () {
      return get(this.form, 'id', null) !== null
    }
  },

  created () {
    this.getAppData()
  }
}
</script>
